import { useEffect, useState } from "react";
import ApiStatus from "../../components/ApiStatus";
import Heading from "../../components/Common/Heading"
import CardGroup from "../../components/Common/CardGroup"
import { useFetchUporabnikMojePrijave } from "./IzobrazevanjePrijavaHooks";
import { IzobrazevanjePrijavaListDto } from "../../types/IzobrazevanjePrijava/IzobrazevanjePrijavaListDto";
import { format } from "date-fns";
import ThumbnailDescriptionCard from "../../components/Common/ThumbnailDescriptionCard";
import { getPathWithBaseURL } from "../../utils/Common";
import styled from "styled-components";
import IzobrazevanjeListGroupFilter from "../izobrazevanje/IzobrazevanjeListGroupFilter";

const StyledIzobrazevanjePregledDiv = styled.div`
    display: flex;
    flex-direction: row;
    gap:95px;
    max-width:1400px;

    .izobrazevanjePregled{
        flex-grow:5;
        flex-basis: 0;
    }

    .izobrazevanjePregled .cards{
        flex-direction:column;
    }

    .izobrazevanjePregled .card{
        width:100%;
        margin-right:0;
    }

    .izobrazevanjePregled .card .middle{
        padding-right:0.4rem;
        justify-content: start;
    }
    
    .izobrazevanjePregled .card .middle p{
        max-height: 65px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .izobrazevanjeCategoryBox{
        flex-grow:2;
        flex-shrink:0;
        margin-top:60px;
        flex-basis: 0;
    }

     @media (max-width: 900px){
        flex-direction: column;
        gap:0;

        .izobrazevanjeCategoryBox{
            order:1;
            margin-top:0;
        }

        .izobrazevanjePregled{
            order:2;
        }
    }
`

interface MojePrijaveTabArgs {
    handleItemClick: (izobrazevanjePrijavaId: number) => void
}

const MojePrijaveTab = ({ handleItemClick }: MojePrijaveTabArgs) => {
    const { data, status, isSuccess } = useFetchUporabnikMojePrijave();
    const [selectedGroups, setSelectedGroups] = useState<string[]>([]);

    useEffect(() => {
        if (data) {
            setSelectedGroups(Object.keys(data));
        }
    }, [data]);

    const handleGroupChange = (groups: string[]) => {
        setSelectedGroups(groups);
    };

    if (!isSuccess)
        return <ApiStatus status={status}></ApiStatus>

    return (
        <>
            <Heading>
                <p>
                    Trenutno ste prijavljeni na naslednja izobraževanja:
                </p>
            </Heading>
            <StyledIzobrazevanjePregledDiv>
                <div className="izobrazevanjePregled">
                    {selectedGroups.map((key) => (
                        <CardGroup key={key} title={`${key}`}>
                            {(data[key] as []).map((izobrazevanje: IzobrazevanjePrijavaListDto) => (
                                <ThumbnailDescriptionCard
                                    key={`${izobrazevanje.izobrazevanjeId}`}
                                    onClick={() => { handleItemClick(izobrazevanje.izobrazevanjeId) }}
                                    color='#397289'
                                    icon="school"
                                    title={`${izobrazevanje.naziv}`}
                                    fromDate={format(new Date(izobrazevanje.datumCasOd), 'dd.MM.yyyy')}
                                    toDate={format(new Date(izobrazevanje.datumCasDo), 'dd.MM.yyyy')}
                                    showProstaMestaLabel={false}
                                    //steviloProstihMest={izobrazevanje.steviloProstihMest}
                                    //prijavaOmejena={izobrazevanje.prijavaOmejena}
                                    stTock={izobrazevanje.tockeSt}
                                    thumbnail={izobrazevanje.thumbnail ? getPathWithBaseURL(izobrazevanje.thumbnail) : null}
                                    description={izobrazevanje.opis}
                                    mentor={izobrazevanje.mentorImePriimek} />
                            ))}
                        </CardGroup>
                    ))}
                </div>
                <div className="izobrazevanjeCategoryBox">
                    <IzobrazevanjeListGroupFilter groups={Object.keys(data).sort()} headerText="Izberite kategorije:" onGroupChange={handleGroupChange} />
                </div>
            </StyledIzobrazevanjePregledDiv>
        </>
    );
}

export default MojePrijaveTab;
